module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('p', {
    staticClass: "chap-title paracenter",
    staticStyle: {
      "margin-top": "3em!important"
    },
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/06_toc#ack"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1",
    staticStyle: {
      "margin-top": "1.5em!important"
    }
  }, [_vm._v("In writing of military operations carried out in this century I have been able to draw on the many excellent articles published in "), _c('em', [_vm._v("The Royal Engineers Journal")]), _vm._v(" My sincere thanks are due to the authors of such articles, details of which are given in the Bibliography. The eleven volumes of "), _c('em', [_vm._v("The History of the Corps of Royal Engineers")]), _vm._v(" have also proved invaluable.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("In addition, many fellow officers and friends have kindly read, given advice and then approved those sections of my draft of which they had detailed knowledge; their help and support is very much appreciated. In particular I would mention Mr J M H Barnard, Major J N Barnikel, Lieutenant Colonel M H Briggs, Dr P S Bulson, Mr E Longbottom, Mr M A Napier, Mr T S Parramore, Major R E Ward, Mr D Webber, the late Brigadiers S A Stewart and H A T Jarrett-Kerr, the late Colonel R T Weld, the late Sir Ralph Freeman and the late Mr A W Hamilton.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I am also indebted to those firms, in addition of course to my sponsors, who have provided information and comments on equipments of their manufacture; namely Balfour Beatty Power Networks Ltd, Butterley Engineering Ltd, Eisenwerke Kaiserslautern GmbH, Laird (Anglesey) Ltd, and Thos Storey (Engineers) Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The photographs and drawings I have collected from many sources, and I have acknowledged sources, where possible, in the illustration captions. The bulk of the earlier photographs included, however, are from the 73,000 or more photographs taken at the Bridging Establishment at Christchurch from 1922 onward, now kept at The Imperial War Museum, London, and reproduced here with kind permission of Mrs Hilary Roberts, Head of Collection Management, Photographic Archives. Some photographs reproduced are Crown Copyright and these have been reproduced by permission of the Ministry of Defence. I am also grateful for permission to reproduce the many photographs included from the Royal Engineer Library at Chatham, and for the assistance given by the Library staff over the years. Assistance provided by Colonel J E Nowers, Director of the Royal Engineer Museum at Chatham, and by Mr D Fletcher, Curator of the Tank Museum at Bovington is also much appreciated.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The five maps were produced to a high standard by Mr D J Cannings and Mrs V T Smith of The Royal School of Military Survey, by kind permission of Lieutenant Colonel J F Prain RE, the Chief Instructor.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("I must also acknowledge use of the title for this book, first proposed by the late Colonel John Davies for his book on military bridging which unfortunately did not progress beyond the stage of a first rough draft and notes, kindly made available to me by his son Christopher.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("Last but by no means least, I gratefully acknowledge the support and patience of my wife Olive, over what has seemed to her an eternity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4479f080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/09_acknowledgement.vue
// module id = 78
// module chunks = 0